<template>
  <div>
    <div v-if="selectedService && serviceData(selectedService).optinAllow && sharedAllowedTime() && !isAsap && !extraStop.length" class="card margin-t-s medium-margin-v-s">
      <div class="availability" v-if="rsvpData.isAirportPickup">
        {{ $t('serviceSelect.availableOnlyFrom') }} <b>{{rsvp.optin.sharedAllowedTime.start}} - {{rsvp.optin.sharedAllowedTime.end}}</b>
      </div>
      <h3 class="margin-t-z margin-b-z">
        {{ $t('serviceSelect.save') }} 
        <b>{{services[selectedService].optinPercent}}%</b>
        {{ $t('serviceSelect.bySharingRide') }} 
      </h3>
      <div class="opt-copy">
        {{ $t('serviceSelect.ifWeFind') }} 
        <b>${{optinRefundPrice().toFixed(2)}}</b>
        {{ $t('serviceSelect.atTheTime') }} 
      </div>
      <div class="opt-check">
        <label>
          <input type="checkbox" v-model="enabled" />
          {{ $t('serviceSelect.iWantTo') }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'optin-shared',
  props: ['leg'],
  data () {
    return {
    }
  },
  computed: {
    rsvp () { return this.$store.state.reservation },
    rsvpData () { return this.rsvp[this.leg] },
    services () { return this.rsvpData.services },
    selectedService () { return this.rsvpData.selectedService },
    isAsap () { return this.rsvpData.isAsap || !this.rsvpData.pickupDate },
    isRoundtrip () { return this.rsvp.isRoundtrip },
    extraStop () { return this.$store.state.reservation.extraStop[this.leg] },
    optin () { return this.rsvp.optin[this.leg] },
    enabled: {
      get () { return this.optin.enabled },
      set (x) {
        this.$store.commit('reservation/setOptinData', {
          leg: this.leg,
          fields: {enabled: x}
        })
      }
    },
    pickupDate () { return this.rsvp[this.leg].pickupDate },
    optinEnabled () { return this.$settings.get('SharedConversionEnabled') }
  },
  methods: {
    serviceData (id) {
      if (!id || !this.services || (this.services && !this.services[id])) return ''
      return this.services[id]
    },
    sharedAllowedTime () {
      if (this.rsvp.optin.sharedAllowedTime.start === this.rsvp.optin.sharedAllowedTime.end) return false
      if (!this.rsvpData.isAirportPickup) { return true }

      let selectedTime = moment()
      if (this.rsvpData.pickupDate) {
        selectedTime = moment(this.rsvpData.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      }

      selectedTime = moment(selectedTime.format('hh:mmA'), 'hh:mmA')
      let allowTimeStart = moment(this.rsvp.optin.sharedAllowedTime.start, 'hh:mmA')
      let allowTimeEnd = moment(this.rsvp.optin.sharedAllowedTime.end, 'hh:mmA')
      return parseInt(selectedTime.format('X')) >= parseInt(allowTimeStart.format('X')) &&
        parseInt(selectedTime.format('X')) <= parseInt(allowTimeEnd.format('X'))
    },
    optinSharedPrice () {
      let pricing = this.isRoundtrip ? 'roundtrip' : 'prices'
      let origPrice = this.services[this.selectedService][pricing][(this.rsvpData.passenger || 1) - 1].price
      let percent = this.services[this.selectedService].optinPercent / 100
      percent = parseFloat((1 - percent).toFixed(2))
      return origPrice * percent
    },
    optinRefundPrice () {
      let pricing = this.isRoundtrip ? 'roundtrip' : 'prices'
      let origPrice = this.services[this.selectedService][pricing][(this.rsvpData.passenger || 1) - 1].price
      return parseFloat((origPrice - this.optinSharedPrice()).toFixed(2))
    }
  },
  watch: {
    selectedService (val) {
      this.enabled = false
    },
    pickupDate (val) {
      if (val) {
        if (!this.sharedAllowedTime()) {
          this.enabled = false
        }
      }
    },
    'rsvpData.isAsap': function (val) {
      if (val) {
        this.enabled = false
        this.$forceUpdate()
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.availability{
  background: #eee;
  padding: 3px 10px;
  margin-bottom: 10px;
  text-align: center;
}
h3{
  font-size: 24px!important;
}
.opt-copy{
  font-size: 18px;
  margin-bottom: 10px;
  color: #2c3e50;
}
.opt-check{
  font-size: 18px;
  display: block;

  label{
    cursor: pointer;
    display: inline-block;
    font-size: 17px;
  }
  input{
    vertical-align: -1px;
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// OptinShared.vue?33a4153c